import type { SVGProps } from 'react';
const SvgIconExpand = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M12 7a.75.75 0 0 0 1.5 0V3.75c0-.69-.56-1.25-1.25-1.25H9A.75.75 0 0 0 9 4h1.94L8.47 6.47a.75.75 0 0 0 1.06 1.06L12 5.06zM4 9a.75.75 0 0 0-1.5 0v3.25c0 .69.56 1.25 1.25 1.25H7A.75.75 0 0 0 7 12H5.06l2.47-2.47a.75.75 0 0 0-1.06-1.06L4 10.94z"
    />
  </svg>
);
export default SvgIconExpand;
